import type { FC } from 'react';

import { Logger } from '../../../../logger/Logger';
import { useActiveDialogCleaner } from '../../../../store/actions/useActiveDialogCleaner';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { useGameStateSlice } from '../../../../store/slices/game/selectors';
import { useHeaderSlice } from '../../../../store/slices/header/selectors';
import { headerActions } from '../../../../store/slices/header/slice';
import { HeaderModal } from '../../../../store/slices/header/types';

import { HistoryControlPlain } from './HistoryControlPlain';

export const HistoryControlConnected: FC = () => {
  const dispatch = useCoreDispatch();
  const openedModal = useHeaderSlice.getCoreOpenedModal();
  const hideUI = useGameStateSlice.hideUI();
  const cleanDialogs = useActiveDialogCleaner();

  return (
    <HistoryControlPlain
      condition={openedModal === HeaderModal.History && !hideUI}
      onClick={(): void => {
        // UIC-64 | Hide Dialogs Functionality
        if (hideUI) {
          cleanDialogs();
        }
        if (!hideUI && openedModal === HeaderModal.History) {
          dispatch(headerActions.setOpenedModal(null));
        } else {
          Logger.logEvent('openBetHistory');
          dispatch(headerActions.setOpenedModal(HeaderModal.History));
        }
      }}
    />
  );
};
